import React, { useEffect } from 'react'
import SignIn from './SignIn'
import { useNavigate, useParams, useLocation } from 'react-router-dom';

const SignInPagePlugin = () => {
  let params = useParams();
  const navigate = useNavigate()
  const location = useLocation();

  useEffect(() => {
    // Preserve any query parameters passed by the plugin (e.g. machine_id, product)
    const searchParams = new URLSearchParams(location.search || window.location.search);
    const machineId = searchParams.get('machine_id');
    const product = searchParams.get('product');

    if (machineId) localStorage.setItem('plugin_machine_id', machineId);
    if (product) localStorage.setItem('plugin_product', product);

    console.log(params.reload);
    if (params.reload == 1) {
      if (searchParams.toString()) {
        navigate(`/signin/plugin/2?${searchParams.toString()}`);
      } else {
        navigate(`/signin/plugin/2`);
      }
      window.location.reload();
    }

    if (params.reload == 2) {
      if (searchParams.toString()) {
        navigate(`/signin/plugin?${searchParams.toString()}`);
      } else {
        navigate(`/signin/plugin`);
      }
    }
  }, [])

  useEffect(() => {
    const timer = setInterval(() => {
      if (params.reload == 1) {
        navigate(`/signin/plugin/2`);
        window.location.reload();
      }
    }, 5000);

    // Clear interval on component unmount
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div>

    </div>
  )
}

export default SignInPagePlugin